export default __webpack_public_path__ + "static/media/imagenLaptop.e1e55072.png";